import ProductChangeRequest from "../../types/ProductChangeRequest";

export const initialUserState = {
    id: 0,
    username: '',
    firstname: '',
    lastname: ''
};

export const prescriptionInit = {
    id: 0,
    user: {
        id: 0,
        username: "",
        firstname: "",
        lastname: ""
    },
    product: {
        id: 0,
        name: ""
    },
    mediator: {
        id: 0,
        firstname: "",
        lastname: "",
        phoneNumber: "",
        birthDate: "",
        place: {
            id: 0,
            name: "",
            city: ""
        }
    },
    phoneNumber: "",
    additionalPhoneNumber: "",
    status: null,
    note: "",
    createdAt: null,
    updatedAt: null,
}

export const productChangeInitialState = {
    fromOther: {
        id: 0,
        childMonth: 0,
        prescription: prescriptionInit,
        user: initialUserState,
        createdAt: null,
        initialMedic: '',
        initialProduct: '',
        productChangerId: 0,
    },
    toOther: {
        id: 0,
        childMonth: 0,
        prescription: prescriptionInit,
        user: initialUserState,
        createdAt: null,
        initialProductId: 0,
        productChanger: ''
    }
}

export const prescriptionInitialState = {
    id: 0,
    user: {
        id: 0,
        username: "",
        firstname: "",
        lastname: ""
    },
    product: {
        id: 0,
        name: ""
    },
    mediator: {
        id: 0,
        firstname: "",
        lastname: "",
        phoneNumber: "",
        birthDate: "",
        place: {
            id: 0,
            name: "",
            city: ""
        }
    },
    phoneNumber: "",
    additionalPhoneNumber: "",
    status: null,
    note: "",
    flagged: false,
    createdAt: null,
    updatedAt: null,
    productChange: productChangeInitialState
}

export const productChangeRequestInitialState: ProductChangeRequest = {
    fromOther: {
        childMonth: 0,
        initialMedic: '',
        initialProductId: 0,
        productChanger: '',
    },
    toOther: {
        childMonth: 0,
        otherProductId: 0,
        productChanger: ''
    }
}